import { useContext, forwardRef } from "react";
import { appContext } from "../../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShieldHeart, faBoltLightning, faTowerBroadcast, faChartLine } from "@fortawesome/free-solid-svg-icons";

export const WhyChooseUsComponent = forwardRef<HTMLDivElement>((props, ref) => {
    const { darkMode } = useContext(appContext);

    const features = [
        {
            icon: faShieldHeart,
            title: "Zero Risk Entry",
            subtitle: "Start in 24 hours",
            description: "No technical knowledge needed. We handle everything from setup to maintenance."
        },
        {
            icon: faBoltLightning,
            title: "Higher Returns",
            subtitle: "1% commission only",
            description: "Lowest fees in the region mean 15-25% more profit in your pocket."
        },
        {
            icon: faTowerBroadcast,
            title: "Always Mining",
            subtitle: "99.9% uptime",
            description: "AI-powered infrastructure ensures maximum profitability, 24/7."
        },
        {
            icon: faChartLine,
            title: "Auto-Optimization",
            subtitle: "Smart switching",
            description: "Automatically switches to most profitable coins for maximum earnings."
        }
    ];

    const stats = [
        { value: "1EH+", label: "Network Power" },
        { value: "1%", label: "Lowest Fee" },
        { value: "99.9%", label: "Uptime" },
        { value: "Instant", label: "Payouts" }
    ];

    return (
        <section ref={ref} className="py-20 relative overflow-hidden min-h-screen flex items-center justify-center">
            <div className="container mx-auto px-4">
                {/* Header */}
                <div className="text-center max-w-2xl mx-auto mb-16">
                    <h2 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-white mb-6">
                        WHY {" "}
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-600">
                            SEGPOOL
                        </span>
                    </h2>
                    
                    <p className="text-lg text-slate-600 dark:text-slate-300 font-medium">
                        Join the mining platform that delivers real results, not just promises.
                    </p>
                </div>

                {/* Features Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
                    {features.map((feature, index) => (
                        <div
                            key={index}
                            className="relative group h-full" // Add h-full here
                        >
                            {/* Card with gradient border */}
                            <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-transparent rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300 opacity-0 group-hover:opacity-100"></div>
                            
                            <div className="relative bg-white dark:bg-slate-900 p-8 rounded-2xl border border-slate-100 dark:border-slate-800 group-hover:border-blue-400/50 transition-all duration-300 hover:-translate-y-2 h-full flex flex-col"> {/* Add h-full and flex flex-col */}
                                {/* Icon */}
                                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center mb-6 shadow-lg">
                                    <FontAwesomeIcon 
                                        icon={feature.icon} 
                                        className="text-white text-xl" 
                                    />
                                </div>
                                
                                {/* Content */}
                                <div className="flex-1 flex flex-col"> {/* Wrap content in flex-1 container */}
                                    <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-2">
                                        {feature.title}
                                    </h3>
                                    <div className="text-blue-500 text-sm font-semibold mb-3">
                                        {feature.subtitle}
                                    </div>
                                    <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed flex-1">
                                        {feature.description}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
});